const SYMBOLS = ['?', '$', 'X', '#', '%', '*'];

function outcomeMeta(outcome) {
  if (outcome === true) return { symbol: '✓', cls: 'win' };
  if (outcome === false) return { symbol: '✗', cls: 'lose' };
  return { symbol: '!', cls: 'error' };
}

function setReel(reelEl, symbol, cls) {
  const span = reelEl.querySelector('.reel-symbol');
  span.textContent = symbol;
  reelEl.classList.remove('win', 'lose', 'error', 'spinning');
  if (cls) reelEl.classList.add(cls);
}

export class ClassicReels {
  constructor(container) {
    this.container = container;
    this.reels = [...container.querySelectorAll('.reel')];
  }

  show() {
    this.container.classList.remove('hidden');
  }
  hide() {
    this.container.classList.add('hidden');
  }

  startSpin() {
    this.reels.forEach((r) => {
      r.classList.add('spinning');
      r.classList.remove('win', 'lose', 'error');
    });
    this._tickHandle = setInterval(() => {
      this.reels.forEach((r) => {
        const s = SYMBOLS[(Math.random() * SYMBOLS.length) | 0];
        r.querySelector('.reel-symbol').textContent = s;
      });
    }, 70);
  }

  async stopSpin(outcome) {
    clearInterval(this._tickHandle);
    const { symbol, cls } = outcomeMeta(outcome);
    for (let i = 0; i < this.reels.length; i++) {
      await new Promise((r) => setTimeout(r, 220));
      setReel(this.reels[i], symbol, cls);
    }
  }
}
